<template>
<ul class="collapsible">
  <li>
    <div class="collapsible-header">{{title}} <i class="material-icons">expand_more</i></div>
    <div class="collapsible-body">
      <slot></slot>
    </div>
  </li>
</ul>
</template>

<script>

export default {
  data: function () {
    return {
    }
  },
  created() {
  	
  },
  mounted(){
    if(this.active){
      var instances = M.Collapsible.init(this.$el, { accordion: false });
    }
  },
  props:{
    title: String,
    active: {
      type: Boolean,
      default: true
    }
  },
  watch: { 
        active: function(newVal, oldVal) {
           if(newVal){
            var instances = M.Collapsible.init(this.$el, { accordion: false });
          }
        }
      },
  methods: {
},

}
</script>

<style scoped>
nav li.menuitems {
    text-transform: uppercase;
    width: 130px;
    text-align: center !important;
    margin-top: 16px;
    background-color: #BEBBBB;
    height: 84px;
}
/*div{
	width: 200px;
}*/
.dropdown-content li.menuitems {
    margin-top: 0px;
    width: 100%;
    height: 20px;
}
li.menuitems > a {
	height: 100% !important;
}
.collapsible-body, .collapsible-header{
  width: 100%;
}
/*.collapsible li i {
  position: absolute;
  right: 4%;
}*/
/deep/ .collapsible li i {
  position: absolute;
  right: 6%;
}

li.active > .collapsible-header > i {
  -ms-transform: rotate(180deg); /* IE 9 */
  -webkit-transform: rotate(180deg); /* Chrome, Safari, Opera */
}
.row{
  width: 100%;
}
</style>
